import React from 'react';

import { VerifyBusinessContext } from '@/context/verifyBusiness';
import { VerifyBusinessAction, VerifyBusinessState } from '@/Screens/VerifyBusiness/reducer';
import { AsAnyActionArg } from '@/utility/reducers';

interface Props {
  readonly reducer: [
    VerifyBusinessState,
    React.ActionDispatch<AsAnyActionArg<VerifyBusinessAction>>,
  ];
}

export const VerifyBusinessProvider: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  return (
    <VerifyBusinessContext.Provider value={props.reducer}>
      {props.children}
    </VerifyBusinessContext.Provider>
  );
};
